import { CREATE_GATEPASS_APPROVAL, CREATE_GATEPASS_APPROVAL_FAILED, CREATE_GATEPASS_APPROVAL_SUCCESS, CREATE_GATEPASS_APPROVER, CREATE_GATEPASS_APPROVER_FAILED, CREATE_GATEPASS_APPROVER_SUCCESS, GET_ALL_APPROVAL_STAFF, GET_ALL_APPROVAL_STAFF_FAILED, GET_ALL_APPROVAL_STAFF_SUCCESS, GET_ALL_GATEPASS_REQUEST, GET_ALL_GATEPASS_REQUEST_FAILED, GET_ALL_GATEPASS_REQUEST_SUCCESS, GET_ALL_STAFF, GET_ALL_STAFF_FAILED, GET_ALL_STAFF_SUCCESS, GET_GATEPASS_REPORT, GET_GATEPASS_REPORT_FAILED, GET_GATEPASS_REPORT_SUCCESS, GET_STAFF_BY_STAFFTYPE, GET_STAFF_BY_STAFFTYPE_FAILED, GET_STAFF_BY_STAFFTYPE_SUCCESS, GET_STAFF_TYPES, GET_STAFF_TYPES_FAILED, GET_STAFF_TYPES_SUCCESS, GET_TEACHER_GATEPASS_REPORT, GET_TEACHER_GATEPASS_REPORT_FAILED, GET_TEACHER_GATEPASS_REPORT_SUCCESS, UPDATE_ADMIN_GATEPASS_REQUEST, UPDATE_ADMIN_GATEPASS_REQUEST_FAILED, UPDATE_ADMIN_GATEPASS_REQUEST_SUCCESS, UPDATE_GATEPASS_REQUEST, UPDATE_GATEPASS_REQUEST_FAILED, UPDATE_GATEPASS_REQUEST_SUCCESS } from "./constants";

export const getStaffTypes = () =>({
    type: GET_STAFF_TYPES
})

export const getStaffTypesSuccess = (payload) =>({
    type: GET_STAFF_TYPES_SUCCESS,
    payload
})


export const getStaffTypesFailed = (payload) =>({
    type: GET_STAFF_TYPES_FAILED,
    payload
})

export const getStaffByStaffType = (payload) =>({
    type: GET_STAFF_BY_STAFFTYPE,
    payload
})

export const getStaffByStaffTypeSuccess = (payload) =>({
    type: GET_STAFF_BY_STAFFTYPE_SUCCESS,
    payload
})

export const getStaffByStaffTypeFailed = (payload) =>({
    type: GET_STAFF_BY_STAFFTYPE_FAILED,
    payload
})

export const createGatePassApprover = (payload) =>({
    type: CREATE_GATEPASS_APPROVER,
    payload
})

export const createGatePassApproverSuccess = (payload) =>({
    type: CREATE_GATEPASS_APPROVER_SUCCESS,
    payload
})


export const createGatePassApproverFailed = (payload) =>({
    type: CREATE_GATEPASS_APPROVER_FAILED,
    payload
})

export const getAllApprovalStaff = () =>({
    type: GET_ALL_APPROVAL_STAFF
})

export const getAllApprovalStaffSuccess = (payload) =>({
    type: GET_ALL_APPROVAL_STAFF_SUCCESS,
    payload
})

export const getAllApprovalStaffFailed = (payload) =>({
    type: GET_ALL_APPROVAL_STAFF_FAILED,
    payload
})

export const getAllGatePassRequest = () =>({
    type: GET_ALL_GATEPASS_REQUEST,
})

export const getAllGatePassRequestSuccess = (payload) =>({
    type: GET_ALL_GATEPASS_REQUEST_SUCCESS,
    payload
})

export const getAllGatePassRequestFailed = (payload) =>({
    type: GET_ALL_GATEPASS_REQUEST_FAILED,
    payload
})

export const updateGatePassRequest = (payload) =>({
    type: UPDATE_GATEPASS_REQUEST,
    payload
})

export const updateGatePassRequestSuccess = (payload) =>({
    type: UPDATE_GATEPASS_REQUEST_SUCCESS,
    payload
})

export const updateGatePassRequestFailed = (payload) =>({
    type: UPDATE_GATEPASS_REQUEST_FAILED,
    payload
})


export const updateAdminGatePassRequest = (payload) =>({
    type: UPDATE_ADMIN_GATEPASS_REQUEST,
    payload
})

export const updateAdminGatePassRequestSuccess = (payload) =>({
    type: UPDATE_ADMIN_GATEPASS_REQUEST_SUCCESS,
    payload
})

export const updateAdminGatePassRequestFailed = (payload) =>({
    type: UPDATE_ADMIN_GATEPASS_REQUEST_FAILED,
    payload
})

export const getTeacherGatePassReport = () =>({
    type: GET_TEACHER_GATEPASS_REPORT

})

export const getTeacherGatePassReportSuccess = (payload) =>({
    type: GET_TEACHER_GATEPASS_REPORT_SUCCESS,
    payload
})

export const getTeacherGatePassReportFailed = (payload) =>({
    type: GET_TEACHER_GATEPASS_REPORT_FAILED,
    payload
})

export const createGatePassApproval = (payload) =>({
    type: CREATE_GATEPASS_APPROVAL,
    payload
})

export const createGatePassApprovalSuccess = (payload) =>({
    type: CREATE_GATEPASS_APPROVAL_SUCCESS,
    payload
})

export const createGatePassApprovalFailed = (payload) =>({
    type: CREATE_GATEPASS_APPROVAL_FAILED,
    payload
})


export const getGatePassReport = (payload) =>({
    type: GET_GATEPASS_REPORT,
    payload
})

export const getGatePassReportSuccess = (payload) =>({
    type: GET_GATEPASS_REPORT_SUCCESS,
    payload
})

export const getGatePassReportFailed = (payload) =>({
    type: GET_GATEPASS_REPORT_FAILED,
    payload
})


export const getAllStaff = () =>({
    type: GET_ALL_STAFF
})

export const getAllStaffSuccess = (payload) =>({
    type: GET_ALL_STAFF_SUCCESS,
    payload
})

export const getAllStaffFailed = (payload) =>({
    type: GET_ALL_STAFF_FAILED,
    payload
})